<template>
  <div id="controls-container">
    <div id="test-info"></div>

    <a id="toolbox"></a>
    <div id="button-showall-container" class="tooltip-container">
      <button id="show_all" type="button" class="styled-button">
        <img src="@/assets/showall_icon.png" alt="Clickable Image" style="width: 35px; height: 20px;">
      </button> 
      <span id="tooltip-showall" class="tooltip"></span>
    </div>

      <div id="button-delete-container" class="tooltip-container">
        <button id="delete" type="button" class="styled-button2">
          <img src="@/assets/delete_icon.png" alt="Clickable Image" class="white-image" style="width: 15px; height: 15px;">
        </button> 
        <span id="tooltip-delete" class="tooltip"></span>
      </div>

      <div id="frame-slider-container" ref="sliderContainer">
        <button id="prev" type="button" class="arrow-button">&lt;</button> 
        <input
          type="range"
          id="frame-slider"
          :min="0"
          :max="maxFrames"
          v-model="currentFrame"
          @input="onFrameSliderChange"
        />
        <button id="next" type="button" class="arrow-button">&gt;</button> 
        <span id="frame-info">Frame: {{ currentFrame }} / {{ maxFrames }}</span>
        <input type="text" id="frame" >

        <div id="button-goFrame-container" class="tooltip-container">
          <button id="go" type="button" class="styled-button1">
            <img src="@/assets/arrow_icon.png" alt="Clickable Image" class="white-image" style="width: 15px; height: 15px;">
          </button> 
          <span id="tooltip-goFrame" class="tooltip"></span>
        </div>

      </div>

      <div id="button-save-container" class="tooltip-container">
        <button id="saveAnnotations" type="button" class="styled-button1">
          <img src="@/assets/save_icon.png" alt="Clickable Image" class="white-image" style="width: 15px; height: 15px;">
        </button> 
        <span id="tooltip-save" class="tooltip"></span>
      </div>

      <div id="button-download-container" class="tooltip-container">
        <button id="loadAnnotations" type="button" class="styled-button1" style="display:none">
          <img src="@/assets/download_icon.png" alt="Clickable Image" class="white-image" style="width: 15px; height: 15px;">
        </button>
        <span id="tooltip-download" class="tooltip"></span>
      </div>
      <div id="versionDropdownContainer"></div>

      <div id="changueClassContainer"></div>

      <div id="button-showtextbox-container" class="tooltip-container">
        <button id="show_textbox" type="button" class="styled-button">
          <img src="@/assets/showtextbox_icon.png" alt="Clickable Image" style="width: 25px; height: 25px;">
        </button> 
        <span id="tooltip-showtextbox" class="tooltip"></span>
      </div>

      <img
        id="loading-gif"
        src="@/assets/loading.gif"
        alt="Loading..."
        style="display: none; width: 45px; height: 45px; margin-left: 10px; vertical-align: middle;"
      >      
    </div>

  <div id="content" ></div>

  <div id="loading-indicator" class="loading-text">Loading DICOM Image<span id="loading-dots">.</span></div>

</template>

<script type="module" src="./CornerstoneTest.js"> </script>

<style>
html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#content {
  width: 100%; /* Ajusta el ancho al contenedor padre */
  height: 100%; /* Ajusta la altura */
  max-width: 90vw; /* Ocupa el 90% del ancho de la ventana */
  max-height: 90vh; /* Ocupa el 90% de la altura de la ventana */
  margin: auto; /* Centrado */
  overflow: auto; /* Permite scroll interno si excede el tamaño */
  display: flex; /* Usa Flexbox para centrar contenido */
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc; /* Borde para visualizar el límite */
}
h3 {
margin: 40px 0 0;
}
ul {
list-style-type: none;
padding: 0;
}
li {
display: inline-block;
margin: 0 10px;
}
a {
margin-left: 10px;
margin-right: 10px;
}
input {
text-align: right;
}

#controls-container {
  position: fixed;       /* Ancla el contenedor */
  top: 0;                /* Posición en la parte superior */
  left: 0;               /* Alineado a la izquierda */
  width: 100%;           /* Que ocupe todo el ancho */
  z-index: 1000;         /* Que esté por encima de otros elementos */
  background-color: white; /* Fondo para que no se mezcle con otros elementos */
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: center;       /* Centra verticalmente */
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1); /* Opcional: sombra sutil */
}

#test-info {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  padding-left: 10px;
  padding-top: 10px;
  text-align: left;
}

#frame-slider-container {
  display: flex; /* Hacer que los elementos se dispongan en una fila */
  align-items: center; /* Centrar verticalmente */
  gap: 10px; /* Espacio entre los elementos */
}
#frame-slider {
  width: 50%; /* Ocupa el 80% del contenedor */
  height: 10px;
}
.arrow-button {
  background-color: transparent; /* Fondo transparente */
  border: none; /* Sin borde */
  font-size: 24px; /* Tamaño de la flecha */
  color: #007bff; /* Azul similar al slider */
  cursor: pointer; /* Cambiar el cursor a mano */
  padding: 0 10px; /* Espaciado alrededor de la flecha */
  display: flex; /* Para alinear verticalmente */
  align-items: center;
}
.arrow-button:hover {
  color: #0056b3; /* Azul más oscuro al pasar el mouse */
}


/* Estilo del tooltip */
/* Contenedor para el botón */
.tooltip-container {
  position: relative; /* Permite posicionar el tooltip relativo al contenedor */
  display: inline-block;
}

/* Tooltip personalizado */
.tooltip {
  position: absolute;
  bottom: 120%; /* Coloca el tooltip encima del botón */
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8); /* Fondo oscuro */
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out;
  z-index: 1000;
}

.tooltip.active {
  opacity: 1;
  visibility: visible;
}

/* Botón estilizado */
.styled-button1 {
  background-color: #efefef; /* Color de fondo */
  border: 1px solid #ccc;   /* Borde */
  border-radius: 5px;       /* Bordes redondeados */
  padding: 10px;            /* Espaciado interno */
  cursor: pointer;          /* Cambiar el cursor a mano */
  display: inline-flex;     /* Para alinear la imagen dentro del botón */
  align-items: center;      /* Centrar verticalmente */
  justify-content: center;  /* Centrar horizontalmente */
  transition: background-color 0.3s ease; /* Transición para hover */
}

/* Cambiar el color de fondo al pasar el ratón */
.styled-button1:hover {
  background-color: #efefefaa; /* Color de fondo al pasar el ratón */
}


.styled-button1 {
  background-color: #007bff; /* Color de fondo */
  border: 1px solid #ccc;   /* Borde */
  border-radius: 5px;       /* Bordes redondeados */
  padding: 10px;            /* Espaciado interno */
  cursor: pointer;          /* Cambiar el cursor a mano */
  display: inline-flex;     /* Para alinear la imagen dentro del botón */
  align-items: center;      /* Centrar verticalmente */
  justify-content: center;  /* Centrar horizontalmente */
  transition: background-color 0.3s ease; /* Transición para hover */
}

/* Cambiar el color de fondo al pasar el ratón */
.styled-button1:hover {
  background-color: #0056b3; /* Color de fondo al pasar el ratón */
}

.styled-button2 {
  background-color: #ff4949; /* Color de fondo */
  border: 1px solid #ccc;   /* Borde */
  border-radius: 5px;       /* Bordes redondeados */
  padding: 10px;            /* Espaciado interno */
  cursor: pointer;          /* Cambiar el cursor a mano */
  display: inline-flex;     /* Para alinear la imagen dentro del botón */
  align-items: center;      /* Centrar verticalmente */
  justify-content: center;  /* Centrar horizontalmente */
  transition: background-color 0.3s ease; /* Transición para hover */
}

/* Cambiar el color de fondo al pasar el ratón */
.styled-button2:hover {
  background-color: #ff4949aa; /* Color de fondo al pasar el ratón */
}

/* Estilos para botones deshabilitados */
.styled-button1:disabled,
.styled-button2:disabled {
  filter: brightness(0.7); /* Reduce el brillo para dar un tono más gris */
  cursor: not-allowed; /* Muestra el cursor de "no permitido" */
  opacity: 0.8; /* Opcional: Reduce la opacidad ligeramente */
}

/* Evita el efecto hover en botones deshabilitados */
.styled-button1:disabled:hover,
.styled-button2:disabled:hover {
  filter: brightness(0.7); /* Mantiene el tono más gris al pasar el ratón */
}

.white-image {
  filter: invert(1) brightness(2);
}

/* Loading text styles */
.loading-text {
  font-size: 1.2rem;
  color: black;
  text-align: center;
  margin-top: 20px;
  font-weight: bold;
  animation: fadein 0.5s ease-in-out;
}

#loading-indicator {
  position: absolute;         /* Posición absoluta para ocupar toda la pantalla */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Centrado exacto */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  z-index: 9999;
}

@keyframes fadein {
  from { opacity: 0; }
  to { opacity: 1; }
}

</style>
